import { render, staticRenderFns } from "./ClaimsLogItem.vue?vue&type=template&id=5dbf18c3&"
import script from "./ClaimsLogItem.vue?vue&type=script&lang=js&"
export * from "./ClaimsLogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports